var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-button responder",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"action-icon far fa-comment-alt"}),_vm._v(" "),_c('p',{staticClass:"action-text"},[_vm._v("Responder")])])}
var staticRenderFns = []

export { render, staticRenderFns }